<button #openAddUserDrawerButton command="show-modal" commandfor="addUserDrawer"
    class="sr-only rounded-md bg-gray-950/5 px-2.5 py-1.5 text-sm font-semibold text-primary hover:bg-gray-950/10">Open
    drawer</button>
<el-dialog>
    <dialog #addUserDrawerDialog id="addUserDrawer" aria-labelledby="addUserDrawer-title"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>
        <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
            (click)="$event.stopPropagation()">

            <el-dialog-panel
                class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-y-auto bg-white shadow-xl rounded-xl">


                    <!-- header -->
                    <!-- <div class="bg-indigo-700 px-2 py-4"> -->
                    <div class="px-2 py-4 drawer-header-primary">
                        <div class="flex space-x-3 h-full items-center">
                            <div class="min-w-0 flex-1 px-2">
                                <p class="text-md font-semibold text-primary">
                                    New Team Member
                                </p>
                                <p class="text-sm text-secondary">
                                    Add a new team member below.
                                </p>
                            </div>

                            <div class="h-full flex flex-col justify-between items-end">

                                <button type="button" (click)="closeDrawer()"
                                    class="btn-fab-secondary text-secondary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5">
                                        <path d="M18 6 6 18" />
                                        <path d="m6 6 12 12" />
                                    </svg>
                                </button>

                            </div>
                        </div>
                    </div>
                    <!-- header - END -->

                    <!-- main content -->
                    @if (runningAddUser()) {
                    <div
                        class="relative h-full flex-1 flex-col items-center justify-center w-full overflow-hidden drawer-body-primary">
                        <div class="w-full h-full flex items-center justify-center py-12">
                            <atom-loading-inline [message]="'This should be done in a moment.'"
                                [title]="'Adding user...'" [loaderSize]="16"></atom-loading-inline>
                        </div>
                    </div>
                    } @else {
                    <div
                        class="relative h-full flex-1 flex-col items-center justify-center w-full overflow-hidden drawer-body-primary">
                        <div class="divide-y divide-white/10 px-4">
                            @if (contextError() || submitError(); as drawerError) {
                            <div role="alert"
                                class="mt-4 flex items-start gap-3 rounded-lg bg-red-50 p-3 inset-ring inset-ring-red-200 dark:bg-red-950/40 dark:inset-ring-red-900/50">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                    stroke-linejoin="round" class="mt-0.5 size-4 shrink-0 text-error"
                                    aria-hidden="true">
                                    <path
                                        d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                    <path d="M12 9v4" />
                                    <path d="M12 17h.01" />
                                </svg>
                                <p class="flex-1 text-sm text-error-dark">{{ drawerError }}</p>
                                @if (!contextError()) {
                                <button type="button" (click)="dismissSubmitError()"
                                    class="shrink-0 rounded p-0.5 text-error hover:opacity-80"
                                    aria-label="Dismiss error">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-4" aria-hidden="true">
                                        <path d="M18 6 6 18" />
                                        <path d="m6 6 12 12" />
                                    </svg>
                                </button>
                                }
                            </div>
                            }
                            <div class="space-y-6 pt-4 pb-2">
                                <div>
                                    <label for="add-user-first-name" class="block text-sm/6 font-medium text-primary">First
                                        Name</label>
                                    <div class="mt-2">
                                        <input [formField]="newUserForm.firstName" id="add-user-first-name" type="text"
                                            class="input-primary text-primary" />
                                        @if (newUserForm.firstName().touched() && newUserForm.firstName().invalid()) {
                                        <ul class="error-list">
                                            @for (error of newUserForm.firstName().errors(); track error) {
                                            <li class="text-error-light flex items-start gap-1">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                                                    class="shrink-0 mt-0.5" aria-hidden="true">
                                                    <path
                                                        d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                                    <path d="M12 9v4" />
                                                    <path d="M12 17h.01" />
                                                </svg>
                                                {{ error.message }}
                                            </li>
                                            }
                                        </ul>
                                        }
                                    </div>
                                </div>

                                <div>
                                    <label for="add-user-last-name" class="block text-sm/6 font-medium text-primary">Last
                                        Name</label>
                                    <div class="mt-2">
                                        <input [formField]="newUserForm.lastName" id="add-user-last-name" type="text"
                                            class="input-primary text-primary" />
                                        @if (newUserForm.lastName().touched() && newUserForm.lastName().invalid()) {
                                        <ul class="error-list">
                                            @for (error of newUserForm.lastName().errors(); track error) {
                                            <li class="text-error-light flex items-start gap-1">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                                                    class="shrink-0 mt-0.5" aria-hidden="true">
                                                    <path
                                                        d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                                    <path d="M12 9v4" />
                                                    <path d="M12 17h.01" />
                                                </svg>
                                                {{ error.message }}
                                            </li>
                                            }
                                        </ul>
                                        }
                                    </div>
                                </div>

                                <div>
                                    <label for="add-user-email" class="block text-sm/6 font-medium text-primary">Email
                                        Address</label>
                                    <div class="mt-2">
                                        <input [formField]="newUserForm.email" id="add-user-email" type="email"
                                            autocomplete="email"
                                            class="input-primary text-primary" />
                                        @if (newUserForm.email().touched() && newUserForm.email().invalid()) {
                                        <ul class="error-list">
                                            @for (error of newUserForm.email().errors(); track error) {
                                            <li class="text-error-light flex items-start gap-1">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                                                    class="shrink-0 mt-0.5" aria-hidden="true">
                                                    <path
                                                        d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                                    <path d="M12 9v4" />
                                                    <path d="M12 17h.01" />
                                                </svg>
                                                {{ error.message }}
                                            </li>
                                            }
                                        </ul>
                                        }
                                    </div>
                                </div>

                                @if (!isAgency()) {
                                <div>
                                    <label for="add-user-job-position"
                                        class="block text-sm/6 font-medium text-primary">Position in the Company
                                        <span class="font-normal text-secondary">(optional)</span></label>
                                    <div class="mt-2">
                                        <input [formField]="newUserForm.jobPosition" id="add-user-job-position"
                                            type="text" class="input-primary text-primary" />
                                    </div>
                                </div>
                                }


                                @if (isAgency()) {
                                <div>
                                    <label for="agency-assign-brands-select"
                                        class="block text-sm/6 font-medium text-gray-900 dark:text-white">Assign to
                                        Brands</label>
                                    @if (brandsError(); as brandsErrorMessage) {
                                    <p role="alert" class="mt-2 text-sm text-error-light">{{ brandsErrorMessage }}</p>
                                    } @else if (displayBrands(); as brands) {
                                    <el-select id="agency-assign-brands-select" name="selected"
                                        [value]="brandSelectControlValue()" class="mt-2 block">
                                        <button type="button"
                                            class="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:focus-visible:outline-primary">
                                            <el-selectedcontent
                                                class="col-start-1 row-start-1 flex items-center gap-3 pr-6">
                                                <img [src]="assignBrandsTriggerLogo()" alt=""
                                                    class="size-5 shrink-0 rounded-full bg-gray-100 dark:bg-gray-700 dark:outline dark:-outline-offset-1 dark:outline-white/10" />
                                                <span class="block truncate">{{ assignBrandsTriggerText() }}</span>
                                            </el-selectedcontent>
                                            <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon"
                                                aria-hidden="true"
                                                class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4 dark:text-gray-400">
                                                <path
                                                    d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                                                    clip-rule="evenodd" fill-rule="evenodd" />
                                            </svg>
                                        </button>

                                        <el-options anchor="bottom start" popover
                                            class="max-h-56 w-(--button-width) overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline-1 outline-black/5 [--anchor-gap:--spacing(1)] data-leave:transition data-leave:transition-discrete data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">
                                            @if (brands.length === 0) {
                                            <div class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400">No brands
                                                available.</div>
                                            } @else {
                                            @for (brand of brands; track brand.id) {
                                            <el-option [value]="brand.id" (click)="onBrandToggle(brand.id, $event)"
                                                class="group/option relative block cursor-pointer py-2 pr-9 pl-3 text-gray-900 select-none focus:bg-primary focus:text-white focus:outline-hidden dark:text-white dark:focus:bg-primary">
                                                <div class="flex items-center">
                                                    <img [src]="brandLogoSrc(brand)" alt=""
                                                        class="size-5 shrink-0 rounded-full" />
                                                    <span class="ml-3 block truncate font-normal"
                                                        [class.font-semibold]="isBrandSelected(brand.id)">{{
                                                        brand.companyName }}</span>
                                                </div>
                                                <span
                                                    class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-focus/option:text-white in-[el-selectedcontent]:hidden"
                                                    [class.hidden]="!isBrandSelected(brand.id)">
                                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon"
                                                        aria-hidden="true" class="size-5">
                                                        <path
                                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                            clip-rule="evenodd" fill-rule="evenodd" />
                                                    </svg>
                                                </span>
                                            </el-option>
                                            }
                                            }
                                        </el-options>
                                    </el-select>
                                    } @else {
                                    <span
                                        class="mt-2 inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 dark:text-white dark:inset-ring-white/10">
                                        <svg aria-hidden="true"
                                            class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="currentColor" />
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="currentFill" />
                                        </svg>

                                        Loading Brands...
                                    </span>
                                    }
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    }
                    <!-- main content - END -->

                    <!-- footer -->
                    <div class="px-4 py-4 drawer-header-primary flex flex-row items-center justify-between gap-x-4">
                        <button type="button" (click)="closeDrawer()"
                            class="text-secondary secondary-button">Cancel</button>

                        <div class="flex flex-row items-center justify-end gap-x-2">
                            @if (runningAddUser()) {
                            <span
                                class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 dark:text-white dark:inset-ring-white/10">
                                <svg aria-hidden="true"
                                    class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor" />
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill" />
                                </svg>
                                Adding User...
                            </span>
                            } @else {
                            <button type="button" (click)="saveTeamMember()" [disabled]="!canSubmit()"
                                class="primary-button">Save</button>
                            }
                        </div>
                    </div>
                    <!-- footer - END -->
                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>